// extracted by mini-css-extract-plugin
export var avatarContainer = "_gr-0";
export var avatarTypingWave = "_gr-i";
export var gray = "_gr-f";
export var green = "_gr-c";
export var icon = "_gr-9";
export var image = "_gr-1";
export var lg = "_gr-6";
export var md = "_gr-5";
export var presenceDot = "_gr-b";
export var red = "_gr-d";
export var sm = "_gr-4";
export var status = "_gr-a";
export var typingDot = "_gr-h";
export var typingPill = "_gr-g";
export var xl = "_gr-7";
export var xs = "_gr-3";
export var xxl = "_gr-8";
export var xxs = "_gr-2";
export var yellow = "_gr-e";